import { Navigate, Outlet } from "react-router-dom";
import { localStorageInstance } from "../../utils/localStorage"

export default function Protected(){
    let auth = localStorageInstance.getItem('token');

    return auth ? <Navigate to='/dashboard'/> : <Outlet/>
}